import { Suspense, useEffect } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import routes from "./config";
import { registerNavigate } from "./navigation";

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      window.requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "auto", block: "start" });
      });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [hash, pathname]);

  useEffect(() => {
    registerNavigate(navigate);
  });

  return (
    <div id="page-content" tabIndex={-1}>
      <Suspense
        fallback={
          <div
            className="flex min-h-screen items-center justify-center bg-white px-4 text-center text-sm text-slate-500 dark:bg-slate-950 dark:text-slate-400"
            role="status"
            aria-live="polite"
          >
            Cargando página…
          </div>
        }
      >
        {element}
      </Suspense>
    </div>
  );
}
